(function (Drupal, once) {
  const interactiveSelector = 'a, button, input, select, textarea';

  function makeRowClickable(row, linkSelector, keyboardRow = false) {
    const link = row.querySelector(linkSelector);

    if (!link) {
      return;
    }

    row.classList.add('is-clickable');

    row.addEventListener('click', (event) => {
      if (
        event.button !== 0
        || event.metaKey
        || event.ctrlKey
        || event.shiftKey
        || event.altKey
        || event.target.closest(interactiveSelector)
      ) {
        return;
      }

      link.click();
    });

    if (!keyboardRow) {
      return;
    }

    row.tabIndex = 0;
    row.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.target.closest(interactiveSelector)) {
        link.click();
      }
    });
  }

  Drupal.behaviors.tableRowLinks = {
    attach(context) {
      once(
        'user-order-row-link',
        '.view-commerce-user-orders.view-display-id-order_page tbody tr',
        context,
      ).forEach((row) => {
        makeRowClickable(row, '.views-field-order-number a', true);
      });

      once(
        'commerce-file-row-link',
        '.view-commerce-file-my-files tbody tr',
        context,
      ).forEach((row) => {
        makeRowClickable(row, '.views-field-commerce-file a[href]');
      });
    },
  };
})(Drupal, once);
